export default __webpack_public_path__ + "static/media/ava-06.2cdc54a3.png";